module.exports = __webpack_public_path__ + "img/ulugames_login.8a4dc4d1.png";